// Layouts
import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/UserPages/AuthLayout.vue";

// Auth/User/Company Pages
import User from "@/pages/Dashboard/UserPages/UserProfile.vue";
import ProjectLogin from "@/pages/Dashboard/UserPages/ProjectLogin.vue";
import AdminLogin from "@/pages/Dashboard/UserPages/AdminLogin.vue";
import Register from "@/pages/Dashboard/UserPages/Register.vue";
import Create from "@/pages/Dashboard/UserPages/Create.vue";
import CompanyProfile from "@/pages/Dashboard/UserPages/CompanyProfile.vue"
import EditUser from "@/pages/Dashboard/UserPages/EditUser.vue";


import Accept from '@/pages/Dashboard/UserPages/Accept.vue';
import Reset from '@/pages/Dashboard/UserPages/Reset.vue';
import SendReset from '@/pages/Dashboard/UserPages/SendReset.vue';
import ConfirmEmail from "@/pages/Dashboard/UserPages/ConfirmEmail.vue";
import Licenses from "@/pages/Dashboard/UserPages/Licenses.vue";
import SetCompany from "@/pages/Dashboard/UserPages/SetCompany.vue";

//Project Pages
import ProjectPortal from "@/pages/Dashboard/ProjectPages/ProjectPortal.vue";
import StartProject from "@/pages/Dashboard/ProjectPages/StartProject.vue";
import StartPrivateProject from "@/pages/Dashboard/ProjectPages/StartPrivateProject.vue";
import Project from "@/pages/Dashboard/ProjectPages/Project.vue";
import ProjectLocation from "@/pages/Dashboard/ProjectPages/ProjectLocation.vue";
import GPRReport from "@/pages/Dashboard/ProjectPages/GPRReport.vue";
import GPRReportView from "@/pages/Dashboard/ProjectPages/Components/GPRReportView.vue";
import JSAView from "@/pages/Dashboard/ProjectPages/Components/JSAView.vue";
import GPRReportEdit from "@/pages/Dashboard/ProjectPages/GPRReportEdit.vue";

import InfoTab from "@/pages/Dashboard/ProjectPages/Components/InfoTab.vue";
import LocationsTab from "@/pages/Dashboard/ProjectPages/Components/LocationsTab/LocationsTab.vue";
import CommentsTab from "@/pages/Dashboard/ProjectPages/Components/CommentsTab.vue";
import PeopleTab from "@/pages/Dashboard/ProjectPages/Components/PeopleTab.vue";
import FilesTab from "@/pages/Dashboard/ProjectPages/Components/FilesTab.vue";
import Scanner from "@/pages/Dashboard/ExtraPages/Scanner.vue";
import Download from "@/pages/Dashboard/UserPages/Download.vue";
import LimitationsDocument from "@/pages/Dashboard/UserPages/LimitationsDocument.vue";
import ProductSpecification from "@/pages/Dashboard/UserPages/ProductSpecification.vue";
import Report from "@/pages/Dashboard/ProjectPages/Components/Report.vue"

//Training and Certification Pages
import TrainingOverview from "@/pages/Dashboard/TrainingPages/TrainingOverview.vue";
import TrainingTest from "@/pages/Dashboard/TrainingPages/TrainingTest.vue";


//Admin Pages
import AdminPortal from "@/pages/Dashboard/AdminPages/AdminPortal.vue";
import AddCompany from "@/pages/Dashboard/AdminPages/AddCompany.vue";
import AllUsers from "@/pages/Dashboard/AdminPages/AllUsers.vue";
import AddUser from "@/pages/Dashboard/AdminPages/AddUser.vue";
import EditCompany from "@/pages/Dashboard/AdminPages/EditCompany.vue";

/////////////////////////////////////////////////////////////

// Creative Tim pages
import Dashboard from "@/pages/Dashboard/ExtraPages/Dashboard.vue";
import Buttons from "@/pages/Dashboard/Components/Buttons.vue";
import GridSystem from "@/pages/Dashboard/Components/GridSystem.vue";
import Panels from "@/pages/Dashboard/Components/Panels.vue";
import SweetAlert from "@/pages/Dashboard/Components/SweetAlert.vue";
import Notifications from "@/pages/Dashboard/Components/Notifications.vue";
import Icons from "@/pages/Dashboard/Components/Icons.vue";
import Typography from "@/pages/Dashboard/Components/Typography.vue";
import RegularForms from "@/pages/Dashboard/Forms/RegularForms.vue";
import ExtendedForms from "@/pages/Dashboard/Forms/ExtendedForms.vue";
import ValidationForms from "@/pages/Dashboard/Forms/ValidationForms.vue";
import Wizard from "@/pages/Dashboard/Forms/Wizard.vue";
import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";
import ExtendedTables from "@/pages/Dashboard/Tables/ExtendedTables.vue";
import PaginatedTables from "@/pages/Dashboard/Tables/PaginatedTables.vue";
import GoogleMaps from "@/pages/Dashboard/Maps/GoogleMaps.vue";
import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";
import VectorMaps from "@/pages/Dashboard/Maps/VectorMaps.vue";
import Calendar from "@/pages/Dashboard/ExtraPages/Calendar.vue";
import Charts from "@/pages/Dashboard/ExtraPages/Charts.vue";
import Widgets from "@/pages/Dashboard/ExtraPages/Widgets.vue";
import Lock from "@/pages/Dashboard/ExtraPages/Lock.vue";
import Pricing from "@/pages/Dashboard/ExtraPages/Pricing.vue";
import TimeLine from "@/pages/Dashboard/ExtraPages/TimeLinePage.vue";

import AutoCompleteInput from "@/pages/Dashboard/ProjectPages/Components/AutoCompleteInput.vue"


import store from "./../store";

let pagesMenu = {
  path: "/",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Profile",
      components: { default: User },
      beforeEnter: requireAuth,
    },
    {
      path: "company",
      name: "Company Profile",
      components: { default: CompanyProfile },
      beforeEnter: requireAuth,
    },
    {
      path: "edituser/:id",
      name: "Edit User",
      components: { default: EditUser },
      beforeEnter: requireAuth
    },
  ],
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/portallogin",
      name: "Project Portal Login",
      component: ProjectLogin
    },
    {
      path: "/adminlogin",
      name: "Admin Portal Login",
      component: AdminLogin
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/create",
      name: "Create",
      component: Create
    },
    {
      path: '/accept',
      name: 'Accept',
      component: Accept
    },
    {
      path: '/reset',
      name: 'Reset',
      component: Reset
    },
    {
      path: '/sendreset',
      name: 'Send Reset',
      component: SendReset
    },
    {
      path: "/confirmemail",
      name: "Confirm Email",
      component: ConfirmEmail
    }
  ]
};

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons }
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem }
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels }
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert }
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications }
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons }
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography }
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: { default: TimeLine }
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock
    },
    {
      path: "calendar",
      name: "Calendar",
      components: { default: Calendar }
    },
    {
      path: "charts",
      name: "Charts",
      components: { default: Charts }
    },
    {
      path: "widgets",
      name: "Widgets",
      components: { default: Widgets }
    }
  ]
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms }
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms }
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms }
    },
    {
      path: "wizard",
      name: "Wizard",
      components: { default: Wizard }
    },
  ]
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables }
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables }
    },
    {
      path: "paginated",
      name: "Pagianted Tables",
      components: { default: PaginatedTables }
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps }
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true,
        navbarAbsolute: true
      },
      components: { default: FullScreenMap }
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: { default: VectorMaps }
    },
  ]
};

let trainingMenu = {
  path: "/training",
  component: DashboardLayout,
  name: "Training",
  redirect: "/training/overview",
  children: [
    {
      path: "overview",
      name: "Training Overview",
      components: { default: TrainingOverview }
    },
    {
      path: "test",
      name: "Training Test",
      components: { default: TrainingTest }
    }
  ]
};


const routes = [
  {
    path: "/",
    redirect: "/portallogin",
    name: "Project Portal Login",
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  authPages,
  trainingMenu,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard },
        beforeEnter: requireAuth,
      },
      {
        path: "projectportal",
        name: "Project Portal",
        components: { default: ProjectPortal },
        beforeEnter: requireAuth,
      },
      {
        path: "adminportal",
        name: "Admin Portal",
        components: { default: AdminPortal },
        beforeEnter: checkAdmin
      },
      {
        path: "startproject",
        name: "Start Project",
        components: { default: StartProject },
        beforeEnter: requireAuth,
      },
      {
        path: "startprivateproject",
        name: "Start Private Project",
        components: { default: StartPrivateProject },
        beforeEnter: requireAuth,
      },
      {
        path: "addcompany",
        name: "Add Company",
        components: { default: AddCompany },
        beforeEnter: checkAdmin
      },
      {
        path: "users",
        name: "All users",
        components: { default: AllUsers },
        beforeEnter: checkAdmin
      },
      {
        path: "edituser/:id",
        name: "Edit User",
        components: { default: EditUser },
        beforeEnter: checkAdmin
      },
      {
        path: "adduser",
        name: "Add User",
        components: { default: AddUser },
        beforeEnter: checkAdmin
      },
      {
        path: "editcompany/:id",
        name: "Edit Company",
        components: { default: EditCompany },
        beforeEnter: checkAdmin
      },
      {
        path: "project",
        name: "Project",
        components: { default: Project },
        beforeEnter: requireAuth,
      },
      {
      	path: 'projects/:id',
      	name: 'Project',
      	components: {default: Project},
      	beforeEnter: requireAuth
      },
      {
      	path: 'projectlocation/:id',
      	name: 'ProjectLocation',
      	components: {default: ProjectLocation},
      	beforeEnter: requireAuth
      },
      {
        path: 'reports/:id',
        name: 'GPR Report PDF',
        components: {default: Report},
        beforeEnter: requireAuth
      },
      {
        path: "setcompany",
        name: "Set Company",
        components: { default: SetCompany },
      },
      {
        path: "licenses",
        name: "Licenses",
        components: { default: Licenses },
      },
      {
        path: "ayto",
        name: "GOogle Maps",
        components: { default: AutoCompleteInput },
      },
      {
        path: "gprreport",
        name: "GPR Report",
        components: { default: GPRReport }
      },
      {
        path: "gprreportview/:id",
        name: "GPR Report View",
        components: { default: GPRReportView }
      },
      {
        path: 'jsaformview/:id',
        name: 'JSA View',
        components: { default: JSAView },
      },
      {
        path: "gprreportedit/:id",
        name: "GPR Report Edit",
        components: { default: GPRReportEdit }
      },
      {
        path: "/scanner",
        name: "Scanner",
        component: Scanner
      },
      {
        path: "/limitationdoc",
        name: "Limitation Doc",
        component: LimitationsDocument
      },
      {
        path: "/guidebook",
        name: "GuideBook",
        component: Download
      },
      {
        path: "/productspecification",
        name: "Product specification",
        component: ProductSpecification
      }
    ],
  },
];


function requireAuth(to, from, next) {
  const { isAuthenticated, needsLicense } = store.getters;
  if (isAuthenticated && needsLicense) {
    next({
      path: '/licenses',
      query: { redirect: to.fullPath }
    });
  } else if (isAuthenticated) {
    next();
  } else {
    next({
      path: "/portallogin",
      query: { redirect: to.fullPath }
    });
  }
}

function checkAdmin(to, from, next) {
  if (store.getters.isAuthenticated && store.getters.isAdmin) {
    next();
  } else {
    next({
      path: "/projectportal",
      query: {redirect: to.fullPath}
    });
  }
}


export default routes;
